import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed-notification d-flex color-white"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex-fill-y ion-justify-content-center ion-align-items-center ion-padding-horizontal bold" }
const _hoisted_4 = { class: "ion-no-margin color-white font-18" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "d-flex ion-align-items-center ion-justify-content-center ion-margin-horizontal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_ctx.notification?.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (_ctx.notification.type === 'success')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require('@/assets/pep/HappyFace.png'),
                alt: ""
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.notification.message), 1),
          (_ctx.notification.link && _ctx.notification.linkText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: _ctx.notification.link,
                  class: "color-white"
                }, _toDisplayString(_ctx.notification.linkText), 9, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ion_button, {
            onClick: _ctx.hide,
            size: "large",
            fill: "clear",
            class: "ion-no-padding"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, {
                icon: _ctx.close,
                size: "large",
                color: "light"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
    : _createCommentVNode("", true)
}